export const FirebaseConfig = {
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "drive2go-c806b",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:605589146816:web:52ef373902de56f474f125",
  databaseURL:
    process.env.REACT_APP_FIREBASE_DATABASE_URL ||
    "https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "drive2go-c806b.firebasestorage.app",
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyA5XP6fNPG-S_ZMlQbzi0o8yH8EBZtM7wQ",

  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "booking.driver2go.fr",

  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "605589146816",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-MZEPGK5G7Q",
  projectNumber: process.env.REACT_APP_FIREBASE_PROJECT_NUMBER || "605589146816",
  version: "2",
};

export const getFunctionsUrl = () => {
  if (process.env.REACT_APP_FUNCTIONS_URL) {
    return process.env.REACT_APP_FUNCTIONS_URL.replace(/\/$/, "");
  }
  const region = process.env.REACT_APP_FUNCTIONS_REGION || "europe-west1";
  const projId = FirebaseConfig.projectId || "drive2go-c806b";
  return `https://${region}-${projId}.cloudfunctions.net`;
};

